"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var FileAttachmentLink = function FileAttachmentLink(_ref) {
  var href = _ref.href,
      filename = _ref.filename,
      type = _ref.type,
      icon = _ref.icon;
  return (0, _preact.h)("a", {
    className: "attachment__link attachment__link--".concat(type, " file-attachment"),
    href: (0, _absoluteUrlRuntime.resolveUrl)(href),
    target: "_blank",
    rel: "noreferrer"
  }, (0, _preact.h)("div", null, icon, (0, _preact.h)("span", {
    className: "file-attachment--filename"
  }, filename)));
};

var _default = FileAttachmentLink;
exports.default = _default;